export const articleContent: Record<string, {
  slug: string;
  title: string;
  author: string;
  date: string;
  category: string;
  categorySlug: string;
  image: string;
  content: Array<{ type: 'paragraph' | 'heading' | 'list' | 'tip'; text?: string; items?: string[] }>;
  relatedSlugs: string[];
}> = {
  'taobao-618-coupon-guide': {
    slug: 'taobao-618-coupon-guide',
    title: '淘宝618大促优惠券领取全攻略，最高省500元',
    author: '福利君',
    date: '2026-08-06',
    category: '限时优惠券',
    categorySlug: 'limited-coupons',
    image: 'https://readdy.ai/api/search-image?query=Taobao%20shopping%20festival%20with%20red%20envelopes%20and%20discount%20banners%2C%20warm%20orange%20festive%20atmosphere%2C%20minimalist%20cream%20background%2C%20clean%20style&width=1200&height=600&seq=art-detail-taobao-01&orientation=landscape',
    content: [
      { type: 'paragraph', text: '618年中大促是上半年最重要的电商购物节，各大平台都会放出海量优惠券。但对于普通消费者来说，优惠券种类繁多，怎么领、怎么用都有讲究。本文将从领取渠道、使用技巧、叠加规则三个方面，帮你理清淘宝618优惠券的完整攻略。' },
      { type: 'heading', text: '一、优惠券领取渠道' },
      { type: 'paragraph', text: '淘宝618优惠券主要通过以下几个渠道发放，建议全部关注，不漏掉任何一张券：' },
      { type: 'list', items: ['主会场领券：进入淘宝App首页的618主会场，每天可领取平台通用券和品类券，一般面额在5-50元不等。', '店铺首页：关注心仪店铺，很多品牌会在店铺首页发放专属优惠券，面额通常比平台券更大。', '直播间领券：618期间各大主播直播间会发放专属优惠券，部分券可与平台券叠加使用。', '会员中心：88VIP会员可额外领取专属大额券，最高可省500元。', '游戏互动：淘宝的618互动小游戏（如叠猫猫）也会赠送优惠券作为奖励。'] },
      { type: 'heading', text: '二、优惠券使用技巧' },
      { type: 'paragraph', text: '领到了优惠券，怎么用才能实现最大优惠？以下是几个关键技巧：' },
      { type: 'list', items: ['凑单技巧：利用跨店满减规则，将不同店铺的商品凑到满减门槛，分摊运费的同时享受更大折扣。', '叠加规则：优先使用店铺券，再使用平台券，最后使用支付优惠（如银行卡立减）。注意阅读券面使用说明。', '比价策略：领券后不要急于下单，在多个平台对比同款商品价格，有时其他平台即使没有券也可能更便宜。', '预售锁定：618预售期间付定金锁价，通常比现货价格更低，且可叠加尾款券使用。'] },
      { type: 'heading', text: '三、重点品类推荐' },
      { type: 'paragraph', text: '根据往年经验，以下品类在618期间的折扣力度最大：' },
      { type: 'list', items: ['数码家电：笔记本、手机、耳机等数码产品通常有品牌官方补贴，降幅在10%-30%。', '美妆护肤：国际大牌和国货品牌都会参与满减和赠品活动，性价比极高。', '家居日用：纸巾、洗衣液等日用品囤货的最佳时机，配合满减券每件可低至5折。', '服饰鞋包：换季清仓叠加618满减，许多品牌折扣可达3-5折。'] },
      { type: 'tip', text: '福利君小贴士：建议提前将心仪商品加入购物车，618当天0点准时下单。热门商品库存有限，手慢真的会无货！同时记得使用返利App再拿一笔返利。' },
    ],
    relatedSlugs: ['jd-supermarket-coupon', 'pdd-bargain-guide', 'credit-card-points-guide'],
  },
  'jd-supermarket-coupon': {
    slug: 'jd-supermarket-coupon',
    title: '京东超市满199减100优惠券限时领取，仅此一天',
    author: '福利君',
    date: '2026-08-06',
    category: '限时优惠券',
    categorySlug: 'limited-coupons',
    image: 'https://readdy.ai/api/search-image?query=JD%20supermarket%20online%20shopping%20cart%20with%20groceries%2C%20red%20discount%20theme%2C%20minimalist%20cream%20background%2C%20clean%20style&width=1200&height=600&seq=art-detail-jd-02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '京东超市推出了满199减100的大额优惠券活动，覆盖零食、日用品、母婴、宠物等多个品类。这个力度在京东超市的历史活动中属于顶级水平，值得重点关注！' },
      { type: 'heading', text: '活动详情' },
      { type: 'list', items: ['活动时间：2026年8月6日 10:00 - 23:59（仅此一天）', '优惠力度：满199元减100元', '适用范围：京东超市自营商品（部分特殊商品除外）', '领取方式：京东App搜索"超市199减100"进入活动页面领取', '使用限制：每人限领1张，数量有限先到先得'] },
      { type: 'heading', text: '凑单推荐' },
      { type: 'paragraph', text: '满199减100意味着你只需要花99元就能买到价值199元的商品，相当于打了5折。以下是一些凑单推荐：' },
      { type: 'list', items: ['零食组合：三只松鼠坚果大礼包 + 良品铺子肉脯组合 + 奥利奥饼干分享装，凑满199元轻松搞定。', '日用品囤货：维达纸巾整箱 + 蓝月亮洗衣液套装 + 舒肤佳沐浴露，日用消耗品囤一次用半年。', '母婴好物：花王纸尿裤 + 贝亲奶瓶 + 全棉时代湿巾，宝妈们的囤货好时机。'] },
      { type: 'tip', text: '福利君小贴士：建议提前加购好心仪商品，到了10点直接下单。这种力度的优惠券通常几分钟就会被抢光！如果抢不到，可以关注下午可能补货的通知。' },
    ],
    relatedSlugs: ['taobao-618-coupon-guide', 'meituan-food-coupon', 'summer-skincare-deals'],
  },
  'meituan-food-coupon': {
    slug: 'meituan-food-coupon',
    title: '美团外卖天天神券领取指南，每单立减5-15元',
    author: '福利君',
    date: '2026-08-05',
    category: '限时优惠券',
    categorySlug: 'limited-coupons',
    image: 'https://readdy.ai/api/search-image?query=Food%20delivery%20bags%20and%20smartphone%20showing%20ordering%20app%2C%20warm%20yellow%20theme%2C%20minimalist%20cream%20background%2C%20clean%20style&width=1200&height=600&seq=art-detail-meituan-02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '美团外卖的天天神券是日常点外卖省钱的神器。只要掌握正确的领取和使用方法，每单外卖都能省下5-15元，一个月下来轻松省出几顿大餐的钱。' },
      { type: 'heading', text: '天天神券领取方法' },
      { type: 'list', items: ['打开美团外卖App，首页即可看到"天天神券"入口，点击进入领取页面。', '每天可领取1-3张优惠券，面额在3-15元不等，具体取决于你的账号等级和消费活跃度。', '每周三和周末通常有加码活动，券面金额更大，建议重点关注。', '邀请好友助力可获得额外的大额优惠券，最高可领20元无门槛券。'] },
      { type: 'heading', text: '配合商家满减使用' },
      { type: 'paragraph', text: '天天神券与商家满减活动可以叠加使用，这是省钱的关键所在：' },
      { type: 'list', items: ['先看商家满减：选择有"满20减5""满30减8"等活动的商家。', '再凑满减门槛：将订单金额凑到满减门槛以上，但不要超出太多。', '最后用神券：在结算页面选择天天神券，系统会自动计算最优组合。', '叠加会员红包：美团会员还可以使用每月赠送的红包，再省一笔。'] },
      { type: 'tip', text: '福利君小贴士：建议在非高峰时段（下午2-5点）点外卖，此时商家满减力度往往更大，且配送费更低。另外，首次绑定银行卡支付通常还有额外立减优惠！' },
    ],
    relatedSlugs: ['jd-supermarket-coupon', 'didi-ride-coupon', 'starbucks-buy1get1'],
  },
};